export default "__VITE_ASSET__q2qLYMQ4__"